import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface Props {
  children: ReactNode
  variant?: 'gray' | 'green' | 'red' | 'blue' | 'amber' | 'violet'
  className?: string
}

const MAP: Record<NonNullable<Props['variant']>, string> = {
  gray:   'bg-gray-100 text-gray-700 ring-gray-200',
  green:  'bg-emerald-50 text-emerald-700 ring-emerald-200',
  red:    'bg-rose-50 text-rose-700 ring-rose-200',
  blue:   'bg-brand-50 text-brand-700 ring-brand-200',
  amber:  'bg-amber-50 text-amber-700 ring-amber-200',
  violet: 'bg-violet-50 text-violet-700 ring-violet-200',
}

export function Badge({ children, variant = 'gray', className }: Props) {
  return (
    <span className={cn(
      'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset',
      MAP[variant],
      className,
    )}>
      {children}
    </span>
  )
}

/** Badge dedicada para status de domínio comuns no projeto. */
export function StatusBadge({ status }: { status: string | null | undefined }) {
  const label = (status ?? '—').toString()
  const PALETTE: Record<string, NonNullable<Props['variant']>> = {
    ATIVO: 'green', INATIVO: 'gray',
    PENDENTE: 'amber', PAGO: 'green', CANCELADO: 'red',
    RECUSADO: 'red', REEMBOLSADO: 'violet', ISENTO: 'violet', PROCESSADO: 'blue',
    TITULAR: 'blue', DEPENDENTE: 'violet',
    'EM ANDAMENTO': 'amber', ACEITO: 'green', REJEITADO: 'red',
  }
  return <Badge variant={PALETTE[label] ?? 'gray'}>{label}</Badge>
}
